<template>
  <div
    class="chat-draggable-container"
    :class="isDragEnter ? 'disable-chat-container' : ''"
    >
    <div class="chat-bot-container" :class="viewHasSidebar ? 'chatbot-container-sidenavbar' : ''">
      <div class="chat-bot-header">
        <img :src="chatBotIconUrl" alt="SBO icon">
        <div class="chat-header-title">
          <span>omniview AI</span>
          <span class="sub-title" >AI chat by Omnicloud</span>
        </div>
        <span class="chat-bot-help-icon" @click="toggleChatbotHelp">?</span>
        <div class="minimize-chat-bot" @click="minimizeChatbot">_</div>
        <div class="close-chat-bot" @click="closeChat"></div>
      </div>
      <div class="chat-bot-responses" id="chatBotResponses" @wheel="onScroll">
        <ul class="messages-list-container">
          <li
            v-for="message, index in chat"
            :key="`chatbot_message.${index}`"
            class="message-item"
            :class="message.from === 'me' ? 'my-message' : 'message-from'">
            <div v-if="message.from === 'me' || message.alreadyShown" v-html="message.body" ></div>
            <Typewriter v-else :text="message.body" :typeChatbot="typeChat" @goToBottom="goToBottom"/>
            <div v-if="message.options" class="options-container">
              <div>{{ message.options.message }}</div>
              <div
                :class="message.options.hasFilters ? '' : 'option-item'"
                @click="continueSteps(option, message.options.hasFilters, message.completed)"
                v-for="option, index in message.options.options" :key="`chatbot_message_option.${index}`">
                {{ option.name }}
                <div class="filters-options" v-if="option.options">
                  <div
                    class="option-item"
                    v-for="(filterOp, index) in option.options"
                    :key="`chatbot_message_option_item.${index}`"
                    @click="setFilter(option.code, index, filterOp, message.completed)">
                    {{ filterOp }}
                  </div>
                </div>
              </div>
            </div>

            <draggable draggable v-if="message.type === 'card'">
              <div draggable class="card-container" @drag=onDrag(message)>
                <div class="icon-container">
                  <feather-icon icon="BarChart2Icon" size="25"/>
                </div>
                <div class="">{{ $t(`chatbot_fake.${message.value.chart}Name`) }}</div>
                <div class="tip">({{ $t('chatbot_fake.tipCard') }})</div>
              </div>
            </draggable>
          </li>
        </ul>
        <div class="readyBtn-bot" v-if="currentStep >= 4 && showReadyBtn" @click="setFinalProcess">{{$t('chatbot_fake.ready')}}</div>
        <div class="loader-container">
          <div class="loaderChatbot" v-if="isLoadingResponse"></div>
        </div>
      </div>
      <div class="chat-bot-queries">
        <textarea
          id="w3review"
          name="w3review"
          rows="4"
          cols="50"
          v-model="myMessage.body"
          @keyup.enter="messageHandler"
          :placeholder="$t('chatbot.input_placeholder')">
        </textarea>
        <div class="chat-bot-btn-send">
          <feather-icon size="20" icon="SendIcon" @click="messageHandler"/>
        </div>
      </div>
    </div>
    <Help v-if="isChatbotHelpOpen"/>
  </div>
</template>

<script>
import { computed, watch } from "@vue/composition-api";
import store from "@/store";
import Typewriter from './TypeWritter.vue'
import Help from  './Help.vue'
import draggable from "vuedraggable";
import { useDefineChatbot } from "@/composables/defineChatbot";
import { useChatbotHelp } from '@/composables/chatbotHelp'

export default {
  components: {
    Typewriter,
    draggable,
    Help
  },
  props: {
    isDragEnter: {
      type: Boolean,
      required: true,
    },
  },
  setup(_, context) {

    const chatBotIconUrl = require('@/assets/images/logo/OmniChatBot.svg')
    const isLoadingResponse = computed(() => store.getters["chatbot/getLoadingStatus"]);
    const { isChatbotHelpOpen, toggleChatbotHelp } = useChatbotHelp()
    const {
      closeChat,
      messageHandler,
      viewHasSidebar,
      onScroll,
      goToBottom,
      chat,
      myMessage,
      continueSteps,
      onDrag,
      setFilter,
      setFinalProcess,
      currentStep,
      showReadyBtn,
      typeChat,
      minimizeChatbot
    } = useDefineChatbot()

    watch(
      () => chat.value,
      () => {
        goToBottom()
      }
    );

    return {
      chatBotIconUrl,
      closeChat,
      messageHandler,
      myMessage,
      continueSteps,
      isLoadingResponse,
      onDrag,
      setFilter,
      setFinalProcess,
      currentStep,
      showReadyBtn,
      viewHasSidebar,
      onScroll,
      goToBottom,
      chat,
      typeChat,
      minimizeChatbot,
      isChatbotHelpOpen,
      toggleChatbotHelp
    };
  },
};
</script>
